import React from "react"
import Recipe from "../schemas/recipe"
import Nutrition from "../schemas/nutrition"

export default function RichSnippet({
  content,
  rating = { ratingValue: 0, reviewCount: 0, bestRating: 0, worstRating: 0 },
  type,
}) {
  console
  let data = ""
  if (type === "recipe") {
    data = Recipe({
      content,
      rating,
    })
  } else {
    data = Nutrition({
      content,
    })
  }
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: data }}
    />
  )
}
